import { Link as StyledLink } from "react-router-dom";

import styled from "@emotion/styled";

export const Link = styled(StyledLink)`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  gap: ${p => p.theme.space[4]}px;

  padding: 12px 16px;

  background-color: ${p => p.theme.colors.accent.green};

  font-size: 16px;
  color: ${p => p.theme.colors.black};
  text-decoration: none;

  border-radius: ${p => p.theme.radii.medium};
  border: 1px solid rgba(255, 255, 255, 0.32);

  transition: background-color 0.3s ease-in-out;

  &:hover {
    background-color: ${p => p.theme.colors.hover.background};
  }

  &:active {
    background-color: ${p => p.theme.colors.active.background};
  }

  @media screen and (min-width: ${props => props.theme.screenSizes.mdMax}) {
    width: auto;
  }
`;
